import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Target, ArrowRight } from 'lucide-react';
import { api, crore } from './targets/api';
import { PaceAlerts } from './targets/PaceAlerts';

export const TargetStrip = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    api('/plans').then(p => api(`/achievement/${p.current_fy}`)).then(setData).catch(() => {});
  }, []);

  if (!data) return null;
  const g = data.group;
  const top = data.companies.flatMap(c => c.business_units).filter(b => b.active && b.target).sort((a, b) => b.target - a.target).slice(0, 5);
  return (
    <div className="bg-white rounded-xl border border-slate-200 p-6" data-testid="dashboard-target-strip">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-red-50 rounded-lg"><Target className="w-5 h-5 text-red-500" /></div>
          <div>
            <h3 className="text-lg font-semibold text-slate-900">{data.fiscal_year} Target vs Won</h3>
            <p className="text-sm text-slate-500">{crore(g.achieved)} won of {crore(g.target)} • {g.achievement_pct}% • gap {crore(g.gap)}</p>
          </div>
        </div>
        <Link to="/sales/targets" className="text-sm text-blue-600 hover:underline flex items-center gap-1" data-testid="dashboard-targets-link">Targets &amp; Roadmap <ArrowRight className="w-4 h-4" /></Link>
      </div>
      <div className="h-3 bg-slate-100 rounded-full overflow-hidden mb-4">
        <div className="h-full bg-gradient-to-r from-amber-400 to-green-500" style={{ width: `${Math.min(g.achievement_pct, 100)}%` }} />
      </div>
      {data.mismatches.length > 0 && <p className="text-xs text-amber-700 mb-3" data-testid="dashboard-mismatch-note">{data.mismatches.length} target level(s) don't add up — review in Targets &amp; Roadmap</p>}
      {data.alerts.length > 0 && <div className="mb-4"><PaceAlerts alerts={data.alerts} fyProgress={data.fy_progress_pct} limit={5} testId="dashboard-pace-alerts" /></div>}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
        {top.map(b => (
          <div key={b.id} className="p-3 bg-slate-50 rounded-lg">
            <p className="text-xs font-medium text-slate-600 truncate">{b.name}</p>
            <p className="text-sm font-semibold text-slate-900 mt-1">{crore(b.achieved)} <span className="text-xs font-normal text-slate-400">/ {crore(b.target)}</span></p>
            <div className="h-1.5 bg-slate-200 rounded-full mt-2 overflow-hidden"><div className="h-full bg-blue-500" style={{ width: `${Math.min(b.achievement_pct, 100)}%` }} /></div>
          </div>
        ))}
      </div>
    </div>
  );
};
